import React from "react";
import { X, AlertCircle, CheckCircle2 } from "lucide-react";

export default function ImportResultModal({ result, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm grid place-items-center p-2 sm:p-4" data-testid="import-result-modal">
      <div className="bg-white rounded-xl shadow-xl border border-slate-200 w-full max-w-xl max-h-[90vh] flex flex-col">
        <div className="p-5 border-b border-slate-200 flex items-center justify-between">
          <h3 className="font-display text-lg font-bold">İçe Aktarım Raporu</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-lg hover:bg-slate-100 grid place-items-center"><X size={16} /></button>
        </div>
        <div className="p-5 space-y-4 overflow-y-auto">
          <div className="grid grid-cols-2 gap-3">
            <div className="rounded-lg bg-emerald-50 border border-emerald-200 p-3 text-center">
              <div className="text-[10px] font-semibold uppercase tracking-wider text-emerald-700">Eklenen</div>
              <div className="text-3xl font-mono-tab font-bold text-emerald-900 mt-1">{result.created}</div>
            </div>
            <div className="rounded-lg bg-amber-50 border border-amber-200 p-3 text-center">
              <div className="text-[10px] font-semibold uppercase tracking-wider text-amber-700">Atlanan (Çakışan)</div>
              <div className="text-3xl font-mono-tab font-bold text-amber-900 mt-1">{result.skipped}</div>
            </div>
          </div>

          {(result.skipped_rows || []).length > 0 && (
            <div>
              <div className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-1.5 flex items-center gap-1.5">
                <AlertCircle size={12} /> Atlanan TC Kimlik Numaraları
              </div>
              <div className="max-h-40 overflow-y-auto border border-amber-200 rounded-lg bg-amber-50/60">
                {result.skipped_rows.map((r, i) => (
                  <div key={i} className="px-3 py-1.5 text-xs flex items-center justify-between border-b border-amber-100 last:border-b-0">
                    <span className="font-mono-tab text-amber-900 font-semibold">{r.sicil_no}</span>
                    <span className="text-amber-800">{r.ad_soyad}</span>
                    <span className="text-amber-700 text-[10px] italic">{r.reason}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {(result.errors || []).length > 0 && (
            <div>
              <div className="text-xs font-semibold uppercase tracking-wider text-rose-700 mb-1.5">Hatalar</div>
              <div className="max-h-32 overflow-y-auto bg-rose-50 border border-rose-200 rounded-lg p-2 text-[11px] font-mono-tab text-rose-900">
                {result.errors.map((e, i) => (<div key={i}>• {e}</div>))}
              </div>
            </div>
          )}

          {result.created > 0 && (
            <div className="text-xs text-emerald-800 inline-flex items-center gap-1.5">
              <CheckCircle2 size={14} /> Yeni personeller listeye eklendi · İşten çıkış tarihi girilenler otomatik <strong>pasif</strong> olarak işaretlendi.
            </div>
          )}
        </div>
        <div className="p-4 border-t border-slate-200 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold"
          >Tamam</button>
        </div>
      </div>
    </div>
  );
}
